import { useRef, useState } from 'react';
import EmailEditor from 'react-email-editor';

const Preview = ({ handleClose, previewData }) => {
  const [showDsk, setshowDsk] = useState(false);
  const emailEditorRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [designJson, setDesignJson] = useState(previewData ? previewData.contentJson : '');

  const handleDsk = () => {
    setshowDsk(true);
  };

  const handleMob = () => {
    setshowDsk(false);
  };

  const onLoad = () => {
    if (designJson) {
      // Parse the design JSON
      let design = JSON.parse(designJson);

      emailEditorRef.current.editor.loadDesign(design);
      const unlayer = emailEditorRef.current?.editor;
      unlayer?.showPreview('tablet');
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <form>
        <div id="genricPopup">
          <div className="popup-backdrop pt-4">
            <div className="popup " style={{ width: '67%', maxWidth: '70%' }}>
              {/* Popup Header */}
              <div className="popup-header">
                <h4 className="popup-title">Test Template</h4>
                <button className="custom-btn-close" onClick={handleClose}></button>
              </div>

              {/* Popup Body */}
              <div className="popup-body">
                <div className="popup-content-block custHgtpreview">
                  <EmailEditor
                    ref={emailEditorRef}
                    onLoad={onLoad}
                    options={{
                      displayMode: 'email',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default Preview;
